import { render, staticRenderFns } from "./OrganismIdcEditAndActionContract.vue?vue&type=template&id=89f15e5a&scoped=true&"
import script from "./OrganismIdcEditAndActionContract.vue?vue&type=script&lang=js&"
export * from "./OrganismIdcEditAndActionContract.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIdcEditAndActionContract.vue?vue&type=style&index=0&id=89f15e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f15e5a",
  null
  
)

export default component.exports